var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { getComments } from "../../../../api/api";
import { useCommentActions } from "../../../../hooks/actions/useCommentActions";
import { WPQTTypes } from "../../../../types/enums";
import { convertCommentFromServer } from "../../../../utils/comment";
import { CommentsAndLogsTabContent, TabContentCommentItem, } from "../CommentsAndLogsTabContent";
function PublicCommentsTabContent({ userId }) {
    const { addComment } = useCommentActions();
    const onAddComment = (newEntry) => __awaiter(this, void 0, void 0, function* () {
        const connemntFromServer = yield addComment(userId, WPQTTypes.User, false, newEntry);
        if (connemntFromServer) {
            return convertCommentFromServer(connemntFromServer);
        }
    });
    const fetchComments = () => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield getComments(userId, WPQTTypes.User, false);
            return response.data.map(convertCommentFromServer);
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to load comments", "quicktasker"));
        }
    });
    return (_jsx(CommentsAndLogsTabContent, { typeId: userId, fetchData: fetchComments, onAdd: onAddComment, renderItem: (comment) => (_jsx(TabContentCommentItem, { item: comment })), noDataMessage: __("No comments available", "quicktasker"), explanation: __("Comments that can be added and viewed by WordPress users (with required permissions) and current QuickTasker user (in user page).", "quicktasker"), enableAdd: true }));
}
export { PublicCommentsTabContent };
